import { render, staticRenderFns } from "./ReviewContentDialog.vue?vue&type=template&id=23bffd76&scoped=true"
import script from "./ReviewContentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewContentDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReviewContentDialog.vue?vue&type=style&index=0&id=23bffd76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bffd76",
  null
  
)

export default component.exports